import CustomersTable from "./CustomersTable";

export default CustomersTable